import {
    initFirebase,
    enableMessagingRegistration,
    disableMessagingRegistration,
} from "~/lib/firebase"
import { optIn, optOut } from "vue-gtag"

// Updates the Authorization header on the given AjaxCtx whenever
// the bearer token change.
export const AuthorizationHeaderPlugin = ctx => store => {
    store.watch(
        state => state.bearerToken,
        bearerToken => {
            if (bearerToken) {
                ctx.defaults.headers["Authorization"] = `Bearer ${bearerToken}`
            } else {
                delete ctx.defaults.headers["Authorization"]
            }
        }
    )
}

// Updates the bearer token on the Service Worker whenever
// the active Service Worker or the bearer token changes.
export const SWBearerTokenPlugin = store => {
    store.watch(
        state => state.bearerToken,
        bearerToken => {
            navigator.serviceWorker.ready.then(registration => {
                registration.active.postMessage({
                    type: "set-bearer-token",
                    token: bearerToken,
                })
            })
        }
    )

    navigator.serviceWorker.addEventListener("controllerchange", () => {
        navigator.serviceWorker.ready.then(registration => {
            registration.active.postMessage({
                type: "set-bearer-token",
                token: store.state.bearerToken,
            })
        })
    })
}

// Registers the user for push notifications whenever
// the active Service Worker or the value of the subscription to push notifications changes
export const SWPushNotificationsPlugin = store => {
    const { commit, dispatch } = store

    function updatePushNotifications({ registration, value }) {
        if (value) {
            initFirebase()
            enableMessagingRegistration({
                serviceWorkerRegistration: registration,
                onTokenUpdate: token =>
                    commit("pushNotifications/setToken", token),
                onNotification: notification =>
                    dispatch("pushNotification", notification),
            })
        } else {
            disableMessagingRegistration({
                onTokenUpdate: token =>
                    commit("pushNotifications/setToken", token),
                onNotification: notification =>
                    dispatch("pushNotification", notification),
            })
        }
    }

    store.watch(
        state => state.pushNotifications.permissions.value,
        value => {
            const { currentUser } = store.getters
            if (!currentUser) return
            navigator.serviceWorker.ready.then(registration => {
                updatePushNotifications({ registration, value })
            })
        }
    )

    navigator.serviceWorker.addEventListener("controllerchange", () => {
        navigator.serviceWorker.ready.then(registration => {
            const { value } = store.state.pushNotifications.permissions
            updatePushNotifications({ registration, value })
        })
    })
}

/**
 * Enables or disables Google Analytics depending on the value of the optional cookies
 */
export const GoogleAnalyticsPlugin = store => {
    store.watch(
        (_state, getters) => getters["cookies/googleAnalyticsIsEnabled"],
        enabled => {
            if (enabled) {
                optIn()
            } else {
                optOut()
            }
        }
    )
}
